import React, { useEffect, useState } from "react";
import { Card, Col, Row, Select, Switch } from "antd";
import { countryRestrictionModel, selection_dropdown } from "../../constants";
import Countries from "../../../../utils/countries.json";

const { Option } = Select;
const CountryRestriction = ({ widget, handleWidgetChange }) => {
  const [countryRestriction, setCountryRestriction] = useState({
    ...countryRestrictionModel,
  });

  const handleSave = () => {
    handleWidgetChange({ countryRestriction, id: widget.id });
  };

  useEffect(() => {
    if (widget.countryRestriction)
      setCountryRestriction({ ...widget.countryRestriction });
    else setCountryRestriction({ ...countryRestrictionModel });
  }, [widget.id, widget.countryRestriction]);

  return (
    <Card className="setting_wrapper">
      <Row className="center_items setting_label">
        <Col span={12}>
          <h4 className="p-color">Countries Restriction</h4>
        </Col>
        <Col span={12} className="action">
          <div style={{ textAlign: "end" }} className="flex_items">
            <Switch
              name="status"
              id="custom-switch"
              checked={countryRestriction.enabled}
              onChange={(checked) => {
                if (!checked)
                  setCountryRestriction({ ...countryRestrictionModel });
                else
                  setCountryRestriction({
                    ...countryRestriction,
                    enabled: checked,
                  });
              }}
            />
          </div>

          <div onClick={handleSave} className="action_btn ml-2">
            <i className="fa-regular fa-floppy-disk"></i>
            <span>Save</span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Select
            disabled={!countryRestriction.enabled}
            className="select_feld"
            placeholder="Select option"
            allowClear={false}
            value={countryRestriction.type}
            onChange={(value) => {
              setCountryRestriction({ ...countryRestriction, type: value });
            }}
          >
            {selection_dropdown.map((x, i) => {
              return (
                <Option key={i} value={x.value}>
                  {x.label} countries
                </Option>
              );
            })}
          </Select>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Select
            disabled={!countryRestriction.enabled}
            className="select_feld"
            maxTagCount="responsive"
            mode="multiple"
            optionFilterProp="children"
            autoComplete="off"
            allowClear
            placeholder="Select countries"
            onChange={(value) => {
              setCountryRestriction({ ...countryRestriction, values: value });
            }}
            value={countryRestriction.values}
          >
            {Countries.map((x) => {
              return (
                <Option key={x.code} value={x.code} label={x.name}>
                  {x.name}
                </Option>
              );
            })}
          </Select>
        </Col>
      </Row>
      <p className="font13">
        By default, the widget will be shown to all visitors. To show or hide
        the widget for visitors from specific countries, enable this
        functionality by selecting the countries.
      </p>
    </Card>
  );
};

export default React.memo(CountryRestriction);
